import $ from 'jquery'
import Typed from 'typed.js'

if ($('.typing').length) {
  new Typed('.typing', {
    stringsElement: '.typing-strings',
    loop: true,
    typeSpeed: 15,
    backSpeed: 5,
  })
}
